module.exports = __webpack_public_path__ + "img/angularjs-development.a3ac03a7.webp";